import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

// WP21 confirms whether the resend actually unblocked the NF-e, which the WP09
// response alone cannot say — Natura can accept the POST and still not invoice.
export default function NfeStatusPanel({ result }) {
  const { t } = useTranslation()
  const key = suffix => `natura_operations.picking.${suffix}`

  if (!result) return null

  const failed = result.outcome !== 'ok'

  return (
    <div
      role="status"
      className={`mt-3 p-3 border rounded text-sm ${failed ? 'border-amber-200 bg-amber-50 text-amber-800' : 'border-gray-200 bg-gray-50 text-gray-700'}`}
    >
      <p className="font-medium">{t(key('nfe_status_heading'))}</p>
      {failed ? (
        <p className="mt-1">{result.message || t(key('nfe_status_unavailable'))}</p>
      ) : (
        <dl className="mt-1 grid grid-cols-2 gap-x-4 gap-y-1">
          <dt className="text-gray-500">{t(key('nfe_status_code'))}</dt>
          <dd className="font-mono">{result.status_code || '—'}</dd>

          <dt className="text-gray-500">{t(key('nfe_status_description'))}</dt>
          <dd>{result.description || '—'}</dd>

          <dt className="text-gray-500">{t(key('nfe_status_action'))}</dt>
          <dd>{result.action || '—'}</dd>

          {result.msg && (
            <>
              <dt className="text-gray-500">{t(key('nfe_status_message'))}</dt>
              <dd className="font-mono break-all">{result.msg}</dd>
            </>
          )}
        </dl>
      )}
    </div>
  )
}

NfeStatusPanel.propTypes = {
  result: PropTypes.object,
}

NfeStatusPanel.defaultProps = {
  result: null,
}
